import { Alert, Button, List, Text } from '@mantine/core';
import { AlertTriangle } from 'react-feather';
import type { FormTimeSlot } from './types';
import { timeSlotFailureMessage, timeSlotFailureTitle, unsavedTimeSlotLines } from './timeSlotCreation';

interface PendingTimeSlotsNoticeProps {
  // Every slot of the wizard, in save order, and the ids of the unsaved ones.
  timeSlots: FormTimeSlot[];
  unsavedSlotIds: string[];
  onReturnToRetry: () => void;
}

// MED-1268: shown on the cohort page while the Create Cohort wizard still
// holds a list of time slots that did not save for this cohort.
export function PendingTimeSlotsNotice({ timeSlots, unsavedSlotIds, onReturnToRetry }: PendingTimeSlotsNoticeProps) {
  const lines = unsavedTimeSlotLines(timeSlots, unsavedSlotIds);
  const totalSlots = timeSlots.length;
  return (
    <Alert
      color="red"
      variant="light"
      icon={<AlertTriangle size={18} />}
      title={timeSlotFailureTitle(lines.length, totalSlots)}
      mb="md"
    >
      <Text size="sm" mb="xs">
        {timeSlotFailureMessage(lines.length, totalSlots)} These time slots are not on this cohort yet:
      </Text>
      <List size="sm" mb="xs">
        {lines.map(line => (
          <List.Item key={line}>{line}</List.Item>
        ))}
      </List>
      <Text size="sm" mb="sm">
        Return to the Create Cohort wizard to retry them, or add them in Edit Cohort Details.
      </Text>
      {/* QA round 5: a filled button, as the Retry Time Slots button in the
          wizard and the buttons in other red alerts. The light variant was
          pale pink on pink. */}
      <Button size="xs" color="red" variant="filled" onClick={onReturnToRetry}>
        Return to Retry
      </Button>
    </Alert>
  );
}
